import { useState } from "react";
import { motion } from "framer-motion";
import { STRIPE_PAYMENT_LINK, PHONE_DISPLAY } from "../data";

export const Payments = () => {
  const [err, setErr] = useState("");
  const submit = (e) => {
    e.preventDefault();
    const inv = e.target.invoice.value.trim();
    const amt = parseFloat(e.target.amount.value);
    if (!inv || !(amt >= 1)) {
      setErr("Enter the invoice number and amount exactly as they appear on your invoice.");
      return;
    }
    if (!STRIPE_PAYMENT_LINK) {
      setErr("Online payment is being set up. For now, please pay through the link on your invoice or text " + PHONE_DISPLAY + ".");
      return;
    }
    setErr("");
    const joiner = STRIPE_PAYMENT_LINK.indexOf("?") > -1 ? "&" : "?";
    window.open(STRIPE_PAYMENT_LINK + joiner + "client_reference_id=" + encodeURIComponent(inv), "_blank", "noopener");
  };

  return (
    <section id="payments" className="section" data-testid="payments-section">
      <motion.h2 className="h2" initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}>
        Quotes and invoices,<br />handled properly.
      </motion.h2>
      <div className="pay-grid">
        <div>
          <p className="sub">No mystery pricing and no paper chase. Every job follows the same clean path, and payment is a secure card checkout powered by Stripe.</p>
          <ol className="steps">
            <li><span className="num">01</span><div><b>Free estimate</b><span>Reach out by text, call, or the request form. Lucho looks at the property and the scope.</span></div></li>
            <li><span className="num">02</span><div><b>Written quote</b><span>You get the number in writing by text or email. Honest quotes, no pressure.</span></div></li>
            <li><span className="num">03</span><div><b>Invoice &amp; secure payment</b><span>When the work is done you get an invoice number. Pay it right here by card, from anywhere in the world.</span></div></li>
          </ol>
        </div>
        <form className="receipt" onSubmit={submit} data-testid="pay-form">
          <p className="receipt-head">Pay an invoice / Lucho Gomez Connect</p>
          <div className="field"><label htmlFor="p-invoice">Invoice number</label><input id="p-invoice" name="invoice" required placeholder="INV-2026-014" data-testid="pay-invoice-input" /></div>
          <div className="field"><label htmlFor="p-amount">Amount (USD)</label><input id="p-amount" name="amount" type="number" min={1} max={25000} step="0.01" required placeholder="250.00" data-testid="pay-amount-input" /></div>
          {err && <p className="err" style={{ color: "#9c2f1b" }} data-testid="pay-error">{err}</p>}
          <button className="paycta" type="submit" data-testid="pay-submit-btn">Pay an invoice</button>
          <p className="receipt-note">Card payments are processed by Stripe on a secure checkout page. Lucho never sees your card details. Use the invoice number and amount from the invoice you received.</p>
        </form>
      </div>
    </section>
  );
};
